import styled from "styled-components";

export const HeaderBarFiltrosKinContainer = styled.div`
  width: 100%;
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 66px;
  padding-right: 79px;
  background: var(--color-primary-gradient);
  box-shadow: 0px 8px 10px rgba(0, 0, 0, 0.14);
  @media (max-width: 1550px) {
    padding-left: 14px;
    padding-right: 16px;
    transition: all 0.5s;
  }
  @media (max-width: 1365px) {
    height: 60px;
    padding-left: 13px;
    padding-right: 10px;
    transition: all 0.5s;
    gap: 50px;

    ${({ isIos }) =>
      isIos === true
        ? `padding-top: 45px;
              height: 110px;
             `
        : `
       `};
  }
`;
